import { createHashRouter, createRoutesFromElements, RouterProvider } from 'react-router-dom'
import ReactDOM from 'react-dom/client'
import { ThemeProvider, SettingsProvider, defaultDrawerSettings } from 'hello-design-system'
import reportWebVitals from 'reportWebVitals'
import { ISpring } from 'contexts/ispring'
import { Assessment } from 'contexts/assessment'
import { Conference } from 'contexts/conference'
import { Booking } from 'contexts/booking'
import { FormbricksProvider } from 'services/formbricks'
import { routes } from 'pages/routes'
import 'hello-design-system/dist/hello-design-system.css'
import 'index.css'
import { rollbarService } from 'services/rollbar'
import microsoftClarity from 'services/microsoft-clarity'
import googleTagManager from 'services/google-tag-manager'
import { GBProvider } from 'growthBookProvider'
import './faroconfig'

rollbarService.updatePayload({
    environment: process.env.REACT_APP_ENV,
    client: {
        javascript: {
            source_map_enabled: true,
            code_version: process.env.REACT_APP_GIT_SHA,
            guess_uncaught_frames: true
        }
    }
})

if (process.env.REACT_APP_MICROSOFT_CLARITY_IS_ENABLED) {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.innerHTML = microsoftClarity
    document.head.appendChild(script)
}

if (process.env.REACT_APP_GTM_IS_ENABLED === 'true') {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.innerHTML = googleTagManager
    document.head.appendChild(script)
}

const start = async (): Promise<void> => {
    if (typeof window !== 'undefined' && 'wakeLock' in navigator) {
        try {
            // prevent the screen from turning off on mobile devices or for screensavers to start on desktop
            await navigator.wakeLock.request('screen')
        } catch (e: any) {
            console.log(e.name, e.message)
        }
    }

    ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
        <>
            <SettingsProvider
                defaultSettings={defaultDrawerSettings}
                defaultThemeSettings={{
                    themeMode: 'light',
                    themeDirection: 'ltr',
                    themeContrast: 'default',
                    themeLayout: 'vertical',
                    themeColorPresets: 'default',
                    themeStretch: false,
                    themeBackground: 'default'
                }}
            >
                <ThemeProvider useGlobalCssBaseline>
                    <Booking>
                        <Conference>
                            <Assessment>
                                <ISpring>
                                    <GBProvider>
                                        <FormbricksProvider>
                                            <RouterProvider router={createHashRouter(createRoutesFromElements(routes))} />
                                        </FormbricksProvider>
                                    </GBProvider>
                                </ISpring>
                            </Assessment>
                        </Conference>
                    </Booking>
                </ThemeProvider>
            </SettingsProvider>
        </>
    )
}

if (process.env.REACT_APP_ENV !== 'local') {
    if ('serviceWorker' in navigator && navigator.serviceWorker.getRegistration) {
        void navigator.serviceWorker.getRegistration().then(reg => {
            if (reg) {
                void reg.unregister().then(() => location.reload())
            }
        })
    }

    void start()

} else if (crossOriginIsolated) {
    void start()

    // Learn more: https://bit.ly/CRA-vitals
    reportWebVitals(vital => console.info(`${vital.name} ${Math.round(vital.value)}ms`)).catch(e => {
        console.error(e)
    })

} else {
    void navigator.serviceWorker.register('sw-f1a3c37f.js', { updateViaCache: 'all' }).then(reg => {
        if (reg.installing) {
            reg.installing.addEventListener('statechange', (ev: any) => {
                if (ev.target?.state) {
                    location.reload()
                }
            })
        }
    })

    ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render('')
}
